if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.getElementById(`product-form-${this.dataset.section}`) || document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector(`product-info[data-section="${this.dataset.section}"]`) || document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateImage();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        // Store references to the main payment button and its parent
        this.mainPaymentBtn = document.querySelector('.shopify-payment-button');
        if (this.mainPaymentBtn) {
          this.mainPaymentBtnParent = this.mainPaymentBtn.parentElement;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);

        // Batch READ
        const atcBarHeight = this.clientHeight;
        const observedElement =
          this.productFormActions.querySelector('button[name="add"], button[type="submit"], .product-form__submit') ||
          this.productFormActions;
        let isMainAtcVisible = true;
        let isFooterVisible = false;

        const hasScrolledPastMainAtc = () => {
          const rect = observedElement.getBoundingClientRect();
          return rect.bottom <= 0;
        };

        const updateVisibility = () => {
          const shouldShow = !isMainAtcVisible && hasScrolledPastMainAtc() && !isFooterVisible;
          this.container.classList.toggle('sticky-atc-bar--show', shouldShow);
        };

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isMainAtcVisible = entry.isIntersecting;
              updateVisibility();

              // Disabled DOM moving of iframe payment button to prevent mobile checkout breaking
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(observedElement);

        const footerEl =
          document.querySelector('.footer') ||
          document.querySelector('footer') ||
          document.querySelector('[id*="footer"]');
        if (footerEl) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                isFooterVisible = entry.isIntersecting;
                updateVisibility();
              });
            },
            { threshold: 0 }
          );
          this.footerObserver.observe(footerEl);
        }

        this._handleStickyVisibilityScroll = updateVisibility;
        window.addEventListener('scroll', this._handleStickyVisibilityScroll, { passive: true });
        updateVisibility();
        this.syncWithMainProductForm();

        // Batch WRITE
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--sticky-atc-bar-height', atcBarHeight + 'px');
        });
      }

      checkDevice() {
        const atcBarHeight = this.clientHeight;
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--sticky-atc-bar-height', atcBarHeight + 'px');
        });
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText =
          addButton.querySelector('.btn__text') ||
          addButton.querySelector('span:not(.btn__icon--bag)');
        if (!addButtonText) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      updateImage() {
        if (!this.currentVariant || !this.currentVariant.featured_image) return;
        
        const src = this.currentVariant.featured_image.src || this.currentVariant.featured_image.url;
        if (!src) return;

        const images = this.querySelectorAll('.sticky-atc-bar__product-image img, .sticky-atc-bar__mobile-thumb img');
        images.forEach((img) => {
          img.setAttribute('src', src);
          img.setAttribute('srcset', src);
        });
      }

      syncWithMainProductForm() {
        // PRIMARY: Watch the main product form's hidden variant input.
        // product-info.js sets this.currentVariant THEN calls updateVariantInputs()
        // which dispatches a 'change' event. We read the variant directly from
        // product-info.currentVariant to get the fresh, correct data.
        const mainForm = this.productFormActions;
        if (mainForm) {
          const mainVariantInput = mainForm.querySelector('input[name="id"]');
          if (mainVariantInput) {
            mainVariantInput.addEventListener('change', () => {
              // Read the variant directly from product-info's live state
              const variant = this.mainProductInfo && this.mainProductInfo.currentVariant;
              if (variant) {
                this._applyVariantToStickyBar(variant);
              } else {
                // Fallback: look up from our own variant data by ID
                const newVariantId = mainVariantInput.value;
                if (newVariantId) {
                  const fallbackVariant = this.variantData.find((v) => v.id === Number(newVariantId));
                  if (fallbackVariant) this._applyVariantToStickyBar(fallbackVariant);
                }
              }
            });
          }
        }

        // FALLBACK: FoxTheme PubSub
        if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || !event.data.variant) return;
            this._applyVariantToStickyBar(event.data.variant);
          });
        }

        // FALLBACK: document-level variant:changed custom event
        document.addEventListener('variant:changed', (event) => {
          if (!event.detail || !event.detail.variant) return;
          this._applyVariantToStickyBar(event.detail.variant);
        });

        // INITIAL SYNC: Apply the variant from the URL on page load.
        // Use requestAnimationFrame to ensure product-info has finished initializing.
        requestAnimationFrame(() => {
          // Try reading from product-info's live state first
          const initialVariant = this.mainProductInfo && this.mainProductInfo.currentVariant;
          if (initialVariant) {
            this._applyVariantToStickyBar(initialVariant);
          } else {
            // Fallback: read variant ID from URL or from the main form input
            const urlParams = new URLSearchParams(window.location.search);
            const urlVariantId = urlParams.get('variant');
            const formVariantId = mainForm && mainForm.querySelector('input[name="id"]')?.value;
            const variantId = urlVariantId || formVariantId;
            if (variantId) {
              const variant = this.variantData.find((v) => v.id === Number(variantId));
              if (variant) this._applyVariantToStickyBar(variant);
            }
          }
        });
      }

      _applyVariantToStickyBar(variant) {
        if (!variant) return;

        this.currentVariant = variant;

        // Update the sticky bar's own select/input
        const variantInput = this.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.value = variant.id;
          const options = variantInput.querySelectorAll('option');
          options.forEach((option) => option.removeAttribute('selected'));
          const selectedOption = variantInput.querySelector(`option[value="${variant.id}"]`);
          if (selectedOption) {
            selectedOption.setAttribute('selected', 'selected');
          }
        }

        this.updatePrice();
        this.updateImage();
        this.updateButton(true, '', false);
        if (!variant.available) {
          this.updateButton(true, FoxTheme.variantStrings.soldOut, true);
        } else {
          this.updateButton(false, '', true);
        }
      }

      disconnectedCallback() {
        // Disabled iframe moving cleanup
        if (this._handleStickyVisibilityScroll) {
          window.removeEventListener('scroll', this._handleStickyVisibilityScroll);
        }
        if (this.observer) this.observer.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
      }
    }
  );
}
